import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.8753 16.8751L13.5836 13.5834M15.417 9.16675C15.417 12.6185 12.6188 15.4167 9.16699 15.4167C5.71521 15.4167 2.91699 12.6185 2.91699 9.16675C2.91699 5.71497 5.71521 2.91675 9.16699 2.91675C12.6188 2.91675 15.417 5.71497 15.417 9.16675Z",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }